import { render, staticRenderFns } from "./SiteNetvisorSalesInvoices.vue?vue&type=template&id=2024ddca&scoped=true"
import script from "./SiteNetvisorSalesInvoices.vue?vue&type=script&lang=js"
export * from "./SiteNetvisorSalesInvoices.vue?vue&type=script&lang=js"
import style0 from "./SiteNetvisorSalesInvoices.vue?vue&type=style&index=0&id=2024ddca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2024ddca",
  null
  
)

export default component.exports